// Solution Type / Crunch Type Names
export const SPEC_SOLUTION_TYPE_NAME = 'Specifications Review'
export const UDR_SOLUTION_TYPE_NAME = 'Universal Document Review'
export const UNIVERSAL_SOLUTION_TYPE_NAME = 'Universal Solution Type'

// With UDR solution type, we had "Document Type" as an extra info collected
export const NDA_DOCUMENT_TYPE = 'NDA'
export const COMMERCIAL_LEASE_DOCUMENT_TYPE = 'Commercial lease agreement'
export const EQUIPMENT_LEASE_DOCUMENT_TYPE = 'Equipment lease agreement'
export const LOAN_AGREEMENT_DOCUMENT_TYPE = 'Loan agreement'

// Document Type Names
export const SPEC_DOC_TYPE_NAME = 'Specifications'
